export const ACCESS_TOKEN_FIELD_NAME = 'hpp-accessToken';
export const REFRESH_TOKEN_FIELD_NAME = 'hpp-refreshToken';
